<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="w-100">
                <h5>Planes de crédito pre-aprobados</h5>
            </div>
            <pos-table class="w-100" tableFormId="creditPlansTable" (dataChange)="this.getCreditPlansData()"
                [data]="creditPlans" [headers]="getCreditPlansHeaders()" [itemsPerPage]="10">
            </pos-table>
        </div>
    </div>


</div>
